const api = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',

  UserLogin: '/index/user_account/login',
  UserLogout: '/index/user_account/logout',
  userGetInfo: '/index/user_account/info',

  TeacherLogin: '/index/teacher_account/login',
  TeacherLogout: '/index/teacher_account/logout',
  TeacherGetInfo: '/index/teacher_account/info'
}
export default api
